import React from 'react'
import AmbulatoryResumeLayout from 'presentation/doctor/layouts/AmbulatoryResume'

function AmbulatoryResume() {
  return <AmbulatoryResumeLayout />
}

export default AmbulatoryResume
